import React from 'react';
import { IProfileArchetype } from '../../types/profile.types';
import './ArchetypeSelector.css';

interface ArchetypeSelectorProps {
  archetypes: IProfileArchetype[];
  selectedId: string | null;
  onSelect: (id: string) => void;
}

const ArchetypeSelector: React.FC<ArchetypeSelectorProps> = ({
  archetypes,
  selectedId,
  onSelect
}) => {
  return (
    <div className='archetype-grid'>
      {archetypes.map((archetype) => (
        <div
          key={archetype._id}
          className={`archetype-card${selectedId === archetype._id ? ' archetype-card--selected' : ''}`}
          style={
            {
              '--archetype-color': archetype.colorTheme,
              borderColor:
                selectedId === archetype._id ? archetype.colorTheme : undefined
            } as React.CSSProperties
          }
          onClick={() => onSelect(archetype._id)}
          role='button'
          tabIndex={0}
          onKeyDown={(e) => e.key === 'Enter' && onSelect(archetype._id)}
          aria-pressed={selectedId === archetype._id}
        >
          {selectedId === archetype._id && (
            <div className='archetype-card__checkmark'>✓</div>
          )}
          <div className='archetype-card__emoji'>{archetype.emoji}</div>
          <div className='archetype-card__name'>{archetype.displayName}</div>
          <div className='archetype-card__description'>
            {archetype.description}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ArchetypeSelector;
